import React, { useEffect } from "react";
import Layout from "./common/Layout";

const PrivacyPolicy = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
        <section className="py-5 bg-light-primary">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <h1 className="display-4 fw-bolder text-primary-s mb-4 wow animated fadeInDown">Privacy Policy</h1>
                <span className="sep mt-4 mx-auto d-block wow animated fadeInUp"></span>
                <p className="lead text-muted mt-4 wow animated fadeInUp">Your privacy is important to us</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="privacy-content">
                  <div className="mb-5">
                    <p className="lead line-h-170">
                      At FloridaDrivingPermit.com, your privacy is important to us. This policy explains how we collect, use, and protect your information when you use our website and enroll in the TLSAE course.
                    </p>
                  </div>

                  <div className="privacy-section mb-5">
                    <h3 className="h4 fw-bold text-primary-s mb-3 d-flex align-items-center">
                      <span className="box-icon me-3">
                        <i className="fa fa-info-circle"></i>
                      </span>
                      1. What Information We Collect
                    </h3>
                    <div className="ps-5">
                      <p className="mb-3">When you register for the course, we collect:</p>
                      <ul className="list-unstyled">
                        <li className="d-flex gap-2 align-items-start py-2">
                          <i className="fa fa-check text-primary-s mt-1"></i>
                          <span>Your full name</span>
                        </li>
                        <li className="d-flex gap-2 align-items-start py-2">
                          <i className="fa fa-check text-primary-s mt-1"></i>
                          <span>Date of birth</span>
                        </li>
                        <li className="d-flex gap-2 align-items-start py-2">
                          <i className="fa fa-check text-primary-s mt-1"></i>
                          <span>Contact information (email, phone, mailing address)</span>
                        </li>
                        <li className="d-flex gap-2 align-items-start py-2">
                          <i className="fa fa-check text-primary-s mt-1"></i>
                          <span>Identification details required to verify your identity</span>
                        </li>
                        <li className="d-flex gap-2 align-items-start py-2">
                          <i className="fa fa-check text-primary-s mt-1"></i>
                          <span>Course progress and test results</span>
                        </li>
                      </ul>
                      <p className="mt-3 text-secondary-s">We <b>do not collect or store</b> your credit card information.</p>
                    </div>
                  </div>

                  <div className="privacy-section mb-5">
                    <h3 className="h4 fw-bold text-primary-s mb-3 d-flex align-items-center">
                      <span className="box-icon me-3">
                        <i className="fa fa-shield-alt"></i>
                      </span>
                      2. Payment Security
                    </h3>
                    <div className="ps-5">
                      <p className="line-h-170">
                        All payments are securely processed through <b>Stripe</b>. Your payment details are encrypted and handled only by Stripe. We never see or store your credit card number.
                      </p>
                    </div>
                  </div>

                  <div className="privacy-section mb-5">
                    <h3 className="h4 fw-bold text-primary-s mb-3 d-flex align-items-center">
                      <span className="box-icon me-3">
                        <i className="fa fa-cogs"></i>
                      </span>
                      3. How We Use Your Information
                    </h3>
                    <div className="ps-5">
                      <p className="mb-3">We use your information to:</p>
                      <ul className="list-unstyled">
                        <li className="d-flex gap-2 align-items-start py-2">
                          <i className="fa fa-angle-right text-primary-s mt-1"></i>
                          <span>Verify your identity throughout the course</span>
                        </li>
                        <li className="d-flex gap-2 align-items-start py-2">
                          <i className="fa fa-angle-right text-primary-s mt-1"></i>
                          <span>Track your course progress</span>
                        </li>
                        <li className="d-flex gap-2 align-items-start py-2">
                          <i className="fa fa-angle-right text-primary-s mt-1"></i>
                          <span>Report your course completion to the <b>Florida HSMV</b></span>
                        </li>
                        <li className="d-flex gap-2 align-items-start py-2">
                          <i className="fa fa-angle-right text-primary-s mt-1"></i>
                          <span>Provide support related to your course access</span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="privacy-section mb-5">
                    <h3 className="h4 fw-bold text-primary-s mb-3 d-flex align-items-center">
                      <span className="box-icon me-3">
                        <i className="fa fa-share-alt"></i>
                      </span>
                      4. Data Sharing
                    </h3>
                    <div className="ps-5">
                      <p className="line-h-170">
                        We <b>do not sell, rent, or trade</b> your personal data to third parties. Your data is only shared with the <b>Florida HSMV</b> to meet course reporting requirements.
                      </p>
                    </div>
                  </div>

                  <div className="privacy-section mb-5">
                    <h3 className="h4 fw-bold text-primary-s mb-3 d-flex align-items-center">
                      <span className="box-icon me-3">
                        <i className="fa fa-user-shield"></i>
                      </span>
                      5. Your Rights
                    </h3>
                    <div className="ps-5">
                      <p className="mb-3">You may request to:</p>
                      <ul className="list-unstyled">
                        <li className="d-flex gap-2 align-items-start py-2">
                        <i className="fa fa-angle-right text-primary-s mt-1"></i>
                        <span>Review the information we have about you</span>
                        </li>
                        <li className="d-flex gap-2 align-items-start py-2">
                        <i className="fa fa-angle-right text-primary-s mt-1"></i>
                        <span>Correct any inaccurate data</span>
                        </li>
                        <li className="d-flex gap-2 align-items-start py-2">
                        <i className="fa fa-angle-right text-primary-s mt-1"></i>
                        <span>Delete your information, if it is no longer needed to fulfill our legal obligations</span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="privacy-section mb-5">
                    <h3 className="h4 fw-bold text-primary-s mb-3 d-flex align-items-center">
                      <span className="box-icon me-3">
                        <i className="fa fa-cookie-bite"></i>
                      </span>
                      6. Cookies and Tracking
                    </h3>
                    <div className="ps-5">
                      <p className="line-h-170">
                        We may use cookies to enhance your course experience, track progress, and improve functionality. You can disable cookies in your browser settings.
                      </p>
                    </div>
                  </div>

                  <div className="privacy-section mb-5">
                    <h3 className="h4 fw-bold text-primary-s mb-3 d-flex align-items-center">
                      <span className="box-icon me-3">
                        <i className="fa fa-lock"></i>
                      </span>
                      7. Data Security
                    </h3>
                    <div className="ps-5">
                      <p className="line-h-170">
                        We use encryption and secure systems to protect your personal data. Access to your data is limited to authorized personnel only.
                      </p>
                    </div>
                  </div>

                  <div className="privacy-section mb-5">
                    <h3 className="h4 fw-bold text-primary-s mb-3 d-flex align-items-center">
                      <span className="box-icon me-3">
                        <i className="fa fa-sync-alt"></i>
                      </span>
                      8. Policy Updates
                    </h3>
                    <div className="ps-5">
                      <p className="line-h-170">
                        We may update this policy from time to time. Changes will be posted on this page with the effective date.
                      </p>
                    </div>
                  </div>

                  
                </div>
              </div>
            </div>
          </div>
        </section>
    </Layout>
  );
};

export default PrivacyPolicy;
